import { FC } from 'react';
import { useSession } from '@nextgen-web-framework/all';
import { SocialShareLink } from '@commerce-webcomponents/ui';
import styles from './SharebarContainer.module.scss';
import type { SharebarContainerPropsTypes } from './types/propsTypes';

const SharebarContainer: FC<SharebarContainerPropsTypes> = ({
  productData,
  subscriptionPlanData,
  bundleStateToBeStored,
  isBundleConditionMatched,
}): React.JSX.Element => {
  const { isABO } = useSession();
  const { productId, productName, brandName, businessVolume, pointValue, productPrice } = productData;

  return (
    <>
      {isABO() && (
        <div className={styles['cpw-sharebar-container']} data-testid="social-share-link-test-id">
          <SocialShareLink
            linkProps={{
              category: 'pdp',
              fullUrl: window?.location?.href,
              title: productData.productName,
              data: JSON.stringify({
                productData: { productId, productName, brandName, businessVolume, pointValue, productPrice },
                subscriptionPlanData,
                [productData.productId]: bundleStateToBeStored,
                isBundleConditionMatched,
              }),
            }}
            shareRestrictions={!!productData.productFlags?.restrictFromSharing}
          />
        </div>
      )}
    </>
  );
};

export default SharebarContainer;
export type { SharebarContainerPropsTypes };
